import React, { Component } from 'react';
import Summary from '../summary';
import _ from 'underscore';

export default class Agenda extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: props.modules,
            activeIndex: 0,
            completed: [],
            ignored: [],
            showLogin: false,
            reservation:{
                date: undefined,
                time: undefined
            },
            contact: {}
        };
        this.onChangeReservation = this.onChangeReservation.bind(this);
        this.addContact = this.addContact.bind(this);
        this.findPrev = this.findPrev.bind(this);
        this.findNext = this.findNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
    }

    onChangeReservation(data){
        this.setState({reservation:{ date: data.date, time: data.time}});
    }
    addContact(data){
        this.setState({contact: data});
    }
    findPrev(prevIndex, newCompleted) {
        let isIgnored;
        if (prevIndex >= 0) {
            isIgnored = _.indexOf(this.state.ignored, this.state.modules[prevIndex].key) !== -1;
            if (isIgnored) {
                this.findNext(prevIndex - 1, newCompleted);
            } else {
                this.setState({
                    activeIndex: prevIndex,
                    completed: newCompleted
                });
            }
        }
    }
    findNext(nextIndex, newCompleted) {
        let isIgnored;
        if (nextIndex < this.state.modules.length) {
            isIgnored = _.indexOf(this.state.ignored, this.state.modules[nextIndex].key) !== -1;
            if (isIgnored) {
                this.findNext(nextIndex + 1, newCompleted);
            } else {
                this.setState({
                    activeIndex: nextIndex,
                    completed: newCompleted
                });
            }
        }
    }
    handlePrev() {
        let completed = this.state.completed;
        completed.pop();
        this.findPrev(this.state.activeIndex - 1, completed);
    }
    handleNext() {

        let completed = this.state.completed;
        completed.push(this.state.modules[this.state.activeIndex]);
        this.findNext(this.state.activeIndex + 1, completed);
    }


    render() {
        let modules = this.props.modules.map(function(module, index) {
            let properties = {
                key: index,
                onNext: this.handleNext,
                onPrev: this.handlePrev,
                active: index === this.state.activeIndex,
                required: module.required,
                moduleKey: module.key
            };
            if (module.key === "zusammenfassung") {
                properties.modulesWithSummaries = this.props.modules.filter(function(module) {
                    return typeof module.summary !== "undefined";
                });
                properties.contactData = this.state.contact;
                properties.reservationData = this.state.reservation;
                properties.ignored = this.state.ignored;
            } else if (module.key === "kontaktdaten") {
                properties.contact = this.addContact;
            } else if (module.key === "danke") {
            } else if (module.key === "termin") {
                properties.reservation = this.onChangeReservation;
            }
            return React.createElement(module.module, properties);
        }.bind(this));


        return (
            <section className="agenda">
                <h2 className="text-uppercase"><i className="fa fa-lg fa-calendar"></i> RDV EN LIGNE</h2>
                <div id="drChrono">
                    <Summary
                        completed={this.state.completed}
                        current={this.props.modules[this.state.activeIndex]}
                        futureItems={this.props.modules.slice(this.state.activeIndex + 1, this.props.modules.length)}
                        ignored={this.state.ignored}
                    />
                    {modules}
                </div>
            </section>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/Agenda.js